// src/utils/get-sections.js
var getCartSectionsToRender = (includeRecommendations = true) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const sectionConfig = [
    {
      id: "cart-items",
      section: (_a = document.querySelector("cart-drawer")) == null ? void 0 : _a.id,
      selector: "#cart-items"
    },
    {
      id: "mobile-recommendations",
      section: (_b = document.querySelector("cart-drawer")) == null ? void 0 : _b.id,
      selector: "#mobile-recommendations"
    },
    {
      id: "cartdrawer-progress",
      section: (_c = document.querySelector("cart-drawer")) == null ? void 0 : _c.id,
      selector: "#cartdrawer-progress"
    },
    {
      id: "cartdrawer-head",
      section: (_d = document.querySelector("cart-drawer")) == null ? void 0 : _d.id,
      selector: "#cartdrawer-head"
    },
    {
      id: "cart-item-counter",
      section: "cart-item-counter",
      selector: "#cart-item-counter"
    },
    {
      id: "cart-footer",
      section: (_e = document.querySelector("cart-drawer")) == null ? void 0 : _e.id,
      selector: "#cart-footer"
    },
    {
      id: "desktop-recommendations",
      section: ((_f = document.querySelector(".main-cart__inner")) == null ? void 0 : _f.id) ? (_g = document.querySelector(".main-cart__inner")) == null ? void 0 : _g.id : (_h = document.querySelector("cart-drawer")) == null ? void 0 : _h.id,
      selector: "#desktop-recommendations"
    },
    {
      id: "cart-summary-desktop",
      section: ((_i = document.querySelector(".main-cart__inner")) == null ? void 0 : _i.id) ? (_j = document.querySelector(".main-cart__inner")) == null ? void 0 : _j.id : (_k = document.querySelector("cart-drawer")) == null ? void 0 : _k.id,
      selector: "#cart-summary-desktop"
    },
    {
      id: "cart-items-desktop",
      section: ((_l = document.querySelector(".main-cart__inner")) == null ? void 0 : _l.id) ? (_m = document.querySelector(".main-cart__inner")) == null ? void 0 : _m.id : (_n = document.querySelector("cart-drawer")) == null ? void 0 : _n.id,
      selector: "#cart-items-desktop"
    }
  ];
  const filtered = includeRecommendations ? sectionConfig : sectionConfig.filter((s) => !["mobile-recommendations", "desktop-recommendations"].includes(s.id));
  return {
    sections: filtered.map((item) => item.section).filter(Boolean),
    selectors: filtered.map((item) => item.selector)
  };
};

// src/utils/section-rendering.js
var renderSections = (dom, sectionsArray) => {
  sectionsArray.forEach((section) => {
    const source = dom.querySelector(section);
    const destination = document.querySelector(section);
    if (source && destination)
      destination.outerHTML = source.outerHTML;
  });
};
var section_rendering_default = renderSections;

// src/extenders/cart-addon-cleanup.js
var CartAddonCleanup = class extends HTMLElement {
  /**
   * Lifecycle hook: initializes ids, subscribes to cleanup events,
   * and runs an initial orphan check.
   */
  connectedCallback() {
    this.giftWrapProductId = parseInt(this.getAttribute("data-giftwrap-product-id") || "", 10);
    this.gemNoteProductId = parseInt(this.getAttribute("data-gemnote-product-id") || "", 10);
    this.running = false;
    this.boundCheck = () => this.checkForOrphans();
    document.documentElement.addEventListener("cart:cleanup:check", this.boundCheck);
    this.checkForOrphans();
  }
  /**
   * Lifecycle hook: unsubscribes from cleanup events.
   */
  disconnectedCallback() {
    if (this.boundCheck) {
      document.documentElement.removeEventListener("cart:cleanup:check", this.boundCheck);
    }
  }
  /**
   * Removes orphan addon lines and refreshes rendered cart sections.
   * Guards against overlapping runs with a local `running` flag.
   */
  checkForOrphans() {
    if (this.running)
      return;
    if (!this.giftWrapProductId && !this.gemNoteProductId)
      return;
    this.running = true;
    fetch("/cart.js").then((r) => r.json()).then((cart) => {
      const items = (cart == null ? void 0 : cart.items) || [];
      const addonItems = items.filter((item) => item.product_id === this.giftWrapProductId || item.product_id === this.gemNoteProductId);
      const parentItems = items.filter((item) => item.product_id !== this.giftWrapProductId && item.product_id !== this.gemNoteProductId);
      const parentKeys = new Set(parentItems.map((item) => item.key));
      const parentLinkIds = new Set(parentItems.map((item) => {
        var _a;
        return (_a = item == null ? void 0 : item.properties) == null ? void 0 : _a._addon_link_id;
      }).filter(Boolean));
      const orphanAddons = addonItems.filter((item) => {
        var _a, _b;
        const belongsToLinkId = (_a = item == null ? void 0 : item.properties) == null ? void 0 : _a._belongs_to_link_id;
        const legacyBelongsTo = (_b = item == null ? void 0 : item.properties) == null ? void 0 : _b._belongs_to;
        if (belongsToLinkId)
          return !parentLinkIds.has(belongsToLinkId);
        if (legacyBelongsTo)
          return !parentKeys.has(legacyBelongsTo);
        return true;
      });
      if (orphanAddons.length === 0)
        return null;
      const { sections, selectors } = getCartSectionsToRender();
      return Promise.allSettled(
        orphanAddons.map((item) => fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        }))
      ).then(() => {
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sections })
        }).then((r) => r.json());
      }).then((sectionsData) => {
        if (sectionsData == null ? void 0 : sectionsData.sections) {
          const parser = new DOMParser();
          Object.entries(sectionsData.sections).forEach(([, value]) => {
            const dom = parser.parseFromString(value, "text/html");
            section_rendering_default(dom, selectors);
          });
        }
      });
    }).catch((error) => {
      console.error("Orphan addon cleanup failed", error);
    }).finally(() => {
      this.running = false;
    });
  }
};
if (!customElements.get("cart-addon-cleanup")) {
  customElements.define("cart-addon-cleanup", CartAddonCleanup);
}
